export default __webpack_public_path__ + "static/media/opened-pokeball.ad705b2a.webp";